import styled from 'styled-components'

import { IconWrapper } from '_components/icon/components'
import { palette } from '_styles/variables'

import { mapper } from '../helpers/alert-mapper'
import { AlertAppearance } from '../helpers/types'

interface Props {
  appearance: AlertAppearance
}

export const Wrapper = styled.div<Props>`
  display: flex;
  position: relative;
  background-color: ${({ appearance }) => mapper[appearance].bgColor};
  border: 1px solid ${({ appearance }) => mapper[appearance].borderColor};
  font-size: 0.875rem;
  border-radius: 0.25rem;
  padding: 0.625rem 2rem 0.625rem 3rem;
  flex-direction: column;
  color: ${palette.neutral['primary-body']};

  & > ${IconWrapper} {
    position: absolute;
    left: 0.75rem;
    color: ${({ appearance }) => mapper[appearance].borderColor};
  }

  & [aria-label='close'] {
    position: absolute;
    right: 0.25rem;
    top: 0.25rem;
    color: ${palette.neutral['grey-icons']};
  }

  & h2,
  h3 {
    margin: 0;
  }

  & h2 {
    font-size: 1.375rem;
  }

  & h3 {
    font-size: 1rem;
    font-weight: 500;
  }
`
